import { PlatformFlagKey } from "@redotech/feature-flags-keys-platform/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { RedoPlatformAuthRpcClientContext } from "@redotech/redo-merchant-app-common/platform/redo-platform-rpc-client-provider";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useQuery } from "@tanstack/react-query";

export function getCustomAnalyticsReportsFeatureFlagQueryKey(teamId: string) {
  return ["customAnalyticsReportsFeatureFlag", teamId] as const;
}

export function useCustomAnalyticsReportsFeatureFlag() {
  const team = useRequiredContext(TeamContext);
  const platformRpcClient = useRequiredContext(
    RedoPlatformAuthRpcClientContext,
  );

  return useQuery({
    queryKey: getCustomAnalyticsReportsFeatureFlagQueryKey(team._id),
    queryFn: async () => {
      const response = await platformRpcClient.getFeatureFlag({
        flagKey: PlatformFlagKey.ANALYTICS_CSV_EXPORT,
      });
      return response.enabled;
    },
  });
}
